import React, { memo } from 'react';
import AiSpeakerName from './ai-speaker-name';
import AiSpeakerMessage from './ai-speaker-message';

/**
 * @prop message - it show the message in copliot chat
 * @prop speaker - it will give who is messaging user or saleshandy-copilot.
 * @prop firstName - it will show firstName of user.
 * @prop lastName - it will show lastName of user.
 * @prop isSameSpeaker - it will identify does the again the message is form same speaker or not
 * @prop isNewMessage - it will identify the latest message generated.
 *
 * @returns React Component
 */
const AiSpeakerChat: React.FC<{
  message: string;
  speaker: string;
  firstName?: string;
  lastName?: string;
  isSameSpeaker?: boolean;
  isNewMessage?: boolean;
}> = ({
  message = '',
  speaker = 'user',
  firstName = '',
  lastName = '',
  isSameSpeaker = false,
  isNewMessage = false,
}) => (
  <div
    className={`ai-speaker-chat-container ${
      isSameSpeaker ? 'same-speaker' : ''
    } ${speaker === 'user' ? 'user' : 'saleshandy-copilot'} ${
      isNewMessage ? 'new-message' : ''
    }`}
  >
    {!isSameSpeaker && (
      <AiSpeakerName
        speaker={speaker}
        firstName={firstName}
        lastName={lastName}
      />
    )}
    <AiSpeakerMessage message={message} speaker={speaker} />
  </div>
);

export default memo(AiSpeakerChat);
